const faq = [
  {
    id: 1,
    question: "How do I choose my Vikinglotto numbers?",
    answer: "Pick 6 main numbers from 1–48 and 1 Viking number from 1–5.",
  },
  {
    id: 2,
    question: "How much does a Vikinglotto ticket cost?",
    answer:
      "The price varies by country, but typically ranges from €1 to €2 per line.",
  },
  {
    id: 3,
    question: "When are the draws held?",
    answer: "Draws take place every Wednesday evening in Norway.",
  },
  {
    id: 4,
    question: "Can I play Vikinglotto from any country?",
    answer:
      "Only players in participating countries can officially play, but some third-party services offer access.",
  },
];

export default faq;
